module.exports = __webpack_public_path__ + "static/media/Foundation.e20945d7.ttf";